import React from "react";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { useDeleteSoftwareAliasMutation } from "../../../crud/software/hooks";
import { useQueryClient } from "react-query";

export type DeleteTarget = {
  accountSlug: string;
  name: string;
};

export const DeleteSoftwareEnvAliasDialog = ({
  open,
  deleteTarget,
  onClose,
}: {
  open: boolean;
  deleteTarget: DeleteTarget;
  onClose: () => void;
}): React.ReactElement => {
  const client = useQueryClient();
  const { mutate, isLoading: deletingSoftwareEnv } =
    useDeleteSoftwareAliasMutation();

  const handleDelete = () => {
    mutate(
      { account: deleteTarget.accountSlug, name: deleteTarget.name },
      {
        onSuccess: () => {
          client.invalidateQueries("softwareAliasList");
          // Potentially invalidate other queries if needed, e.g., specific alias details
          onClose();
        },
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Software Environment?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to permanently delete the software environment
          alias <strong>{deleteTarget.name}</strong>? This action cannot be
          undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="secondary"
          disabled={deletingSoftwareEnv}
          onClick={onClose}
        >
          Cancel
        </Button>
        <LoadingButton
          autoFocus
          color="error"
          startIcon={<Delete />}
          variant="outlined"
          loading={deletingSoftwareEnv}
          onClick={handleDelete}
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
